import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* getAmbassadorApplicationAgreement() {
  const { success, data, error } = yield* makeRequest.get("/application_agreement", { kind: "ambassador" });

  if (success && data) {
    yield put(actions.setAmbassadorApplicationAgreement(keysToCamelCase(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_AMBASSADOR_APPLICATION_AGREEMENT,
    });
  }

  return null;
}

export default getAmbassadorApplicationAgreement;
